import styled from 'styled-components';
import VoiceInputWaveform from './VoiceInputWaveform';
import VoiceRecordingControls from './VoiceRecordingControls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Bar = styled.div.withConfig({
  displayName: "VoiceRecordingBar__Bar"
})(["display:flex;align-items:center;gap:8px;width:100%;min-width:0;"]);
const VoiceRecordingBar = () => /*#__PURE__*/_jsxs(Bar, {
  children: [/*#__PURE__*/_jsx(VoiceInputWaveform, {}), /*#__PURE__*/_jsx(VoiceRecordingControls, {})]
});
VoiceRecordingBar.displayName = 'VoiceRecordingBar';
export default VoiceRecordingBar;